module.exports = __webpack_public_path__ + "static/media/ios-rainy.37dde442.svg";